"use client";

import React from "react";
import { graphql } from "gatsby";
import { FinancialReports } from "@app/components/financial-reports/FinancialReports";

const FinancialReportPage = () => <FinancialReports />;

export default FinancialReportPage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
